const w = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 11.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5z"/></svg>';
export {
  w
};
